import { render, staticRenderFns } from "./AnswerTypeRadioButton.vue?vue&type=template&id=5b3efb87&scoped=true"
import script from "./AnswerTypeRadioButton.vue?vue&type=script&lang=js"
export * from "./AnswerTypeRadioButton.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeRadioButton.vue?vue&type=style&index=0&id=5b3efb87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3efb87",
  null
  
)

export default component.exports